<div *ngIf="!showRequest">
  <h2 class="sectionTitle">{{'FRONT_USER.AccurateForm.FormHeader' | translate }}</h2>
  <div *ngIf="baseRequestId" class="read-only-content">
    <!--request Details summary-->
     <app-transit-request [IsAdminMode]="true" #transitRequest></app-transit-request>
  </div>

     <form name="accurateDataForm" [formGroup]="accurateDataForm">
      <div class="form-container" #accurateDataFormControls>
          <div class="form-section">
              <h4 class="section-title">{{'FRONT_USER.AccurateForm.FormHeader' | translate }}</h4>
              <div class="form-group">
                <label for="Accurate_DFWD">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.D_FWD' | translate}}</label>

                <input type="text" name="Accurate_DFWD" id="Accurate_DFWD" class="form-control" formControlName="Accurate_DFWD">
                <div *ngIf="formSubmitted || (f.Accurate_DFWD?.dirty && f.Accurate_DFWD?.errors)" class="red ">
                  <div *ngIf="f.Accurate_DFWD?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="f.Accurate_DFWD?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                  <div *ngIf="f.Accurate_DFWD?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_150_ERROR' | translate}}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="Accurate_DAFT">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.D_AFT' | translate}}</label>

                <input type="text" name="Accurate_DAFT" id="Accurate_DAFT" class="form-control" formControlName="Accurate_DAFT">
                <div *ngIf="formSubmitted || (f.Accurate_DAFT?.dirty && f.Accurate_DAFT?.errors)" class="red ">
                  <div *ngIf="f.Accurate_DAFT?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="f.Accurate_DAFT?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                  <div *ngIf="f.Accurate_DAFT?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_150_ERROR' | translate}}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="Accurate_AirDraught">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.AIR_DRAUGHT' | translate}}</label>

                <input type="text" name="Accurate_AirDraught" id="Accurate_AirDraught" class="form-control" formControlName="Accurate_AirDraught">
                <div *ngIf="formSubmitted || (f.Accurate_AirDraught?.dirty && f.Accurate_AirDraught?.errors)" class="red ">
                  <div *ngIf="f.Accurate_AirDraught?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="f.Accurate_AirDraught?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                  <div *ngIf="f.Accurate_AirDraught?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_150_ERROR' | translate}}
                  </div>

                </div>
              </div>

              <div class="form-group">
                <label for="Accurate_PropellerTypes">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.PROPELLER_TYPE' | translate}}</label>

                <textarea type="text" name="Accurate_PropellerTypes" id="Accurate_PropellerTypes" class="form-control"
                  formControlName="Accurate_PropellerTypes"> </textarea>

                <div *ngIf="formSubmitted || (f.Accurate_PropellerTypes?.dirty && f.Accurate_PropellerTypes?.errors)" class="red ">
                  <div *ngIf="f.Accurate_PropellerTypes?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="f.Accurate_PropellerTypes?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="Accurate_Anchor">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.ANCHORS' | translate}}</label>

                <textarea type="text" name="Accurate_Anchor" id="Accurate_Anchor" class="form-control"
                  formControlName="Accurate_Anchor"> </textarea>
                <div *ngIf="formSubmitted || (f.Accurate_Anchor?.dirty && f.Accurate_Anchor?.errors)" class="red ">
                  <div *ngIf="f.Accurate_Anchor?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="f.Accurate_Anchor?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="Accurate_Cranes">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.SHIPS_CRANES' | translate}}</label>

                <textarea type="text" name="Accurate_Cranes" id="Accurate_Cranes" class="form-control"
                  formControlName="Accurate_Cranes"></textarea>
                <div *ngIf="formSubmitted || (f.Accurate_Cranes?.dirty && f.Accurate_Cranes?.errors)" class="red ">
                  <div *ngIf="f.Accurate_Cranes?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="f.Accurate_Cranes?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label
                  for="Accurate_MaxSpeed">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.MAX_MANOUVERING_SPEED' | translate}}</label>

                <input type="text" name="Accurate_MaxSpeed" id="Accurate_MaxSpeed" class="form-control"
                  formControlName="Accurate_MaxSpeed" />
                <div *ngIf="formSubmitted || (f.Accurate_MaxSpeed?.dirty && f.Accurate_MaxSpeed?.errors)"
                  class="red ">
                  <div *ngIf="f.Accurate_MaxSpeed?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="f.Accurate_MaxSpeed?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                  <div *ngIf="f.Accurate_MaxSpeed?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_150_ERROR' | translate}}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label
                  for="Accurate_MinSpeed">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.Min_MANOUVERING_SPEED' | translate}}</label>

                <input type="text" name="Accurate_MinSpeed" id="Accurate_MinSpeed" class="form-control"
                  formControlName="Accurate_MinSpeed" />
                  <div *ngIf="formSubmitted || (f.Accurate_MinSpeed?.dirty && f.Accurate_MinSpeed?.errors)"
                  class="red ">
                  <div *ngIf="f.Accurate_MinSpeed?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="f.Accurate_MinSpeed?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                  <div *ngIf="f.Accurate_MinSpeed?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_150_ERROR' | translate}}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="SecurityLevelId">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.SECURITY_LEVEL' | translate}}</label>

                <select formControlName="Accurate_Securitylevel" id="Accurate_Securitylevel" name="Accurate_Securitylevel" class="form-control"
                  [ngClass]="{ 'is-invalid': formSubmitted || (f.Accurate_Securitylevel?.dirty && f.Accurate_Securitylevel?.errors) }">
                  <option [value]="''" selected>
                    {{'FRONT_USER.TRANSIT_REQUEST_FORM.CHOOSE_SECURITY_LEVEL' | translate}}
                  </option>
                  <ng-container *ngFor="let level of securityLevels">
                    <option *ngIf="displayedLang == 2" [value]="level.Id">
                      {{level.NameEN}}
                    </option>
                    <option *ngIf="displayedLang == 1" [value]="level.Id">
                      {{level.NameAR}}
                    </option>
                  </ng-container>
                </select>

                <div *ngIf="formSubmitted || (f.Accurate_Securitylevel?.dirty && f.Accurate_Securitylevel?.errors)" class="red ">
                  <div *ngIf="f.SecurityLevelId?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="Accurate_FloatingUnits">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.FLOATING_UNITS' | translate}}</label>

                <textarea type="text" name="Accurate_FloatingUnits" id="Accurate_FloatingUnits" class="form-control"
                  formControlName="Accurate_FloatingUnits"> </textarea>

                <div *ngIf="formSubmitted || (f.Accurate_FloatingUnits?.dirty && f.Accurate_FloatingUnits?.errors)" class="red ">
                  <div *ngIf="f.Accurate_FloatingUnits?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="f.Accurate_FloatingUnits?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="Accurate_Extensions">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.EXTINTIONS' | translate}}</label>

                <textarea type="text" name="Accurate_Extensions" id="Accurate_Extensions" class="form-control"
                  formControlName="Accurate_Extensions"> </textarea>

                <div *ngIf="formSubmitted || (f.Accurate_Extensions?.dirty && f.Accurate_Extensions?.errors)" class="red ">
                  <div *ngIf="f.Accurate_Extensions?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="f.Accurate_Extensions?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label
                  for="Accurate_RegisterCertificateExpireDate">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.REGISTERY_CERTIFICATE' | translate}}</label>

                <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker name="Accurate_RegisterCertificateExpireDate"
                  id="Accurate_RegisterCertificateExpireDate" formControlName="Accurate_RegisterCertificateExpireDate">

                <div *ngIf="formSubmitted || (f.Accurate_RegisterCertificateExpireDate?.dirty && f.Accurate_RegisterCertificateExpireDate?.errors)"
                  class="red ">
                  <div *ngIf="f.Accurate_RegisterCertificateExpireDate?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="f.Accurate_RegisterCertificateExpireDate?.errors?.inValidDateError">
                    {{'FRONT_USER.DATE_ERROR' | translate}}
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="Accurate_Note">Note</label>
                <textarea name="Accurate_Note" id="Accurate_Note" name="Accurate_Note" formControlName="Accurate_Note" class="form-control"></textarea>
              </div>
          </div>
        </div>
        <div class="form-group">
          <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="submit()">Submit</button>
          <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button>
      </div>
     </form>


  <br>
</div>
